import UserApi from "../../services/api/User";
import ActionTypes from "./ActionTypes";

function handleError(err) {
  console.log("error in user actions:", err);
}

export const isUserValid = () => async (dispatch) => {
  try {
    let response = await UserApi.isUserValid();
    if (response) {
      return response;
    }
  } catch (err) {
    handleError(err);
  }
};

export const setStatus = (payload) => {
  return {
    type: ActionTypes.SET_ERROR,
    payload,
  };
};

export const setLoader = (payload) => {
  return {
    type: ActionTypes.SET_LOADER,
    payload,
  };
};

export const setSideBarCollapsed = (payload) => {
  return {
    type: ActionTypes.SET_SIDEBAR_COLLAPSED,
    payload,
  };
};

export const setUploadedFileName = (payload) => {
  return {
    type: ActionTypes.SET_UPLOADED_FILE_NAME,
    payload,
  };
};

export const setActiveFilePath = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILE_PATH,
    payload,
  };
};

export const setUploadedImageName = (payload) => {
  return {
    type: ActionTypes.SET_UPLOADED_IMAGE_NAME,
    payload,
  };
};

export const setUploadedVideoName = (payload) => {
  return {
    type: ActionTypes.SET_UPLOADED_VIDEO_NAME,
    payload,
  };
};

export const setActiveCsvHeaders = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_CSV_HEADERS,
    payload,
  };
};
